//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import {
		mapState
	} from 'vuex'
	import {
		boxList
	} from '@/api'
	//专区箱子
	export default {
		name: 'home',
		components: {
			//sTswiper: () => import('./components/swiper/index.vue'),
			// notice: () => import('./components/notice/index.vue'),
		},
		data() {
			return {
				Height: 0,
				swiperShow: false,
				box_list: []
			}
		},

		created() {
			this.set_official_loading(true)
			/*if (sessionStorage.getItem('swiperShow')) {
				this.swiperShow = JSON.parse(sessionStorage.getItem('swiperShow'))
			}*/
			this.getListBoxZone()
		},

		mounted() {

		},
		methods: {

			//滚动(top)
			totop() {
				this.$el.querySelector('.top').scrollIntoView({
					behavior: "smooth", // 平滑过渡
					block: "start" // 上边框与视窗顶部平齐。默认值
				})
			},
			close() {
				this.swiperShow = false
			},

			// 首页信息
			getListBoxZone() {
				boxList().then(res => {
					if(res.data.code== 0){
						this.box_list = res.data.data;
						this.set_official_loading(false)
					}else{
						this.set_official_loading(false)
					}
				}).catch(err => this.set_official_loading(false))
			},

			to_open(id) {
					this.$router.push({
						path: '/official/open',
						query: {
							id: id
						}
					})
			},
		},
		computed: {
			...mapState(['se_scroll','top_scroll'])
		},
		
		beforeDestroy() {
		},
		watch: {

			swiperShow(v) {
				sessionStorage.setItem('swiperShow', v)
			}
		}
	}
